import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import enUS from "date-fns/locale/en-US";
import { format, parse, startOfWeek, getDay } from "date-fns";
import { useState, useMemo, useEffect } from "react";
import BreadcrumbCom from "../../../common/components/BreadcrumbCom";
import { useSelector } from "react-redux";
import { selectListItems } from "../../../redux/library/selector";
import { CalendarList } from "./calendar-list";
import { useNavigate } from "react-router-dom";
import { selectRecurringOrdersListItems } from "../../../redux/recurring-orders/selector";
import { useAppDispatch } from "../../../hooks/hooks";
import { ListCriteria } from "../../types/list-criteria";
import { events } from "../../../redux/event/events/action";
import { selectEventsListItems } from "../../../redux/event/events/selector";

const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({
	format,
	parse,
	startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
	getDay,
	locales,
});

const OneuserCalendar = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const libraryData = useSelector(selectListItems)

	const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
	const [currentDate, setCurrentDate] = useState(new Date());
	const [draftOrder, setDraftOrder]: any = useState([]);
	const [selectedEvent, setSelectedEvent]: any = useState(null);

	const recurringOrdersList = useSelector(selectEventsListItems)
	
	useEffect(() => {
		console.log('recurringOrdersList', recurringOrdersList)
		setSelectedEvent(recurringOrdersList?.result?.items)
	}, [recurringOrdersList]);

	const generateOrders = (date: Date) => {
		const base = moment(date).startOf("month");

		return [
			{
				id: 1,
				title: "Order #1001 - John Doe",
				start: base.clone().add(5, "days").hour(10).minute(0).toDate(),
				end: base.clone().add(5, "days").hour(11).minute(30).toDate(),
				status: "Pending",
			},
			{
				id: 2,
				title: "Order #1002 - Jane Smith",
				start: base.clone().add(10, "days").hour(14).minute(0).toDate(),
				end: base.clone().add(10, "days").hour(15).minute(0).toDate(),
				status: "Shipped",
			},
			{
				id: 3,
				title: "Order #1003 - Mark Wilson",
				start: base.clone().add(15, "days").hour(9).minute(0).toDate(),
				end: base.clone().add(15, "days").hour(10).minute(30).toDate(),
				status: "Delivered",
			},
			{
				id: 4,
				title: "Order #1004 - Alice Brown",
				start: base.clone().add(20, "days").hour(13).minute(0).toDate(),
				end: base.clone().add(20, "days").hour(14).minute(0).toDate(),
				status: "Cancelled",
			},
		];
	};

	const eventStyleGetter = (event: any) => {
		let statusClass = `rbc-event-status-${event.status}`;
		return { className: statusClass };
	};

	const handleNavigate = (date: Date) => {
		setCurrentDate(date);
	};

	const handleSelectSlot = (start: any) => {
		console.log('start', start)
	};

	const handleSelectEvent = (item: any) => {
		navigate(`/dbnshop/subscriptions/order/order-details?order_id=${item?.orderPid}`)
	};

	const fetchSubscriptionsList = ({
			searchCriteria,
			filterCriteria,
			dateCriteria
		}: ListCriteria) => {
			dispatch(events.list({
				url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,
				entity: 'events',
				jsonData: {
					Context: {},
					Records: [{}],
					Pagination: {
						"PageNumber": pageData,
						"PageSize": pageSize,
						"SortField": "Id",
						"SortOrder": "desc",
					}
				}
			}))
		}

		useEffect(() => {
			fetchSubscriptionsList({});
		}, []);
	

	useEffect(() => {
		let draftOrder: any = []
		selectedEvent?.map((events: any, index: any) => {
			draftOrder.push(
				
				{
					"Title": ` ${events?.Name}`,
					"StartDateOnUtc": moment(events?.StartDateUtc).day(index).toDate(),
					"EndDateOnUtc": moment(events?.EndDateUtc).day(index).toDate(),
					"CreatedOn": moment(events?.StartDateUtc).day(index).toDate(),
				})
		})
		setDraftOrder(draftOrder)
	}, [selectedEvent])

	return (
		<>
		
			<div className="flex flex-row mb-4 space-y-4 px-6 justify-between items-center">
				<h2 className="text-left text-xl font-normal text-primary sm:text-xl md:text-2xl">Calendar</h2>
				
			</div>

			<div className="flex flex-row justify-start items-center p-2 w-full h-full min-h-[600px] bg-slate-300 px-10 bg-red-500">
				
				<div className="flex flex-row justify-Start items-start  p-2 w-full h-full bg-slate-300 px-10">
					<div className="flex w-1/2 h-screen">
					<Calendar
						localizer={localizer}
						events={draftOrder}
						selectable
						onSelectSlot={(e) => handleSelectSlot(e)}
						startAccessor="StartDateOnUtc"
						endAccessor="EndDateOnUtc"
						onSelectEvent={handleSelectEvent}
						titleAccessor="Title"
						eventPropGetter={eventStyleGetter}
						defaultView="month"
						views={['month', 'week', 'day']}
						popup
						className="rounded border"
						style={{height: 600, width: 600}}
					/>
					</div>
					
					<div className="flex w-1/2">
					<CalendarList subscriptions={draftOrder}/>
					</div>
				</div >
			</div>

		</>
	);
};

export default OneuserCalendar;
